import { render } from "./PageStyleguide.vue?vue&type=template&id=21ca6399"
import script from "./PageStyleguide.vue?vue&type=script&lang=js"
export * from "./PageStyleguide.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__